<template>
  <div class="py-5">
    <b-form novalidate @submit="onSubmit" @change="onChange" @reset="onReset">
      <b-overlay :show="loading" rounded opacity="0.6" spinner-small spinner-variant="primary"
        class="d-inline-block w-100" @hidden="onOverlayHidden">
        <b-container>
          <h2>{{ title }}</h2>
          <b-row>
            <b-col>
              <AdminProductBaseSettings :form="form">
                <b-col>
                  <FormElementInput name="namn" v-model="elementValueName" @input="elementValueName = $event" />
                </b-col>
                <b-col cols="3">
                  <FormElementInput name="lockid" v-model="elementValueLockid"
                    @input="elementValueLockid = $event, elementValueArtnr = $event" />
                </b-col>
              </AdminProductBaseSettings>

              <!-- Edit facts -->
              <div v-if="showOriginal" class="mt-5">
                <h3>{{ $t("text.fakta") }}</h3>
                <table class="table facts">
                  <tbody>
                    <tr v-for="(fact, i) in form.facts" :key="`fact-${i}`">
                      <th>{{ $t(fact.title) }}</th>
                      <td>
                        <div v-if="factsOptions[fact.title] && factsOptions[fact.title].options">
                          <div v-if="Array.isArray(fact.value)">
                            <b-form-checkbox-group v-model="fact.value" :options="factsOptions[fact.title].options"
                              :name="`fact-options-${i}`"></b-form-checkbox-group>
                          </div>
                          <div v-else><b-form-radio-group v-model="fact.value"
                              :options="factsOptions[fact.title].options"
                              :name="`fact-options-${i}`"></b-form-radio-group></div>
                        </div>
                        <!-- If fact.value is an array and has multiple values -->
                        <div v-if="Array.isArray(fact.value) && !factsOptions[fact.title].options"
                          class="d-flex flex-wrap input-gap">
                          <div v-for="(value, j) in fact.value" :key="`fact-value-${j}`">
                            <b-input-group>
                              <b-form-input v-model="fact.value[j]" type="number"></b-form-input>
                              <b-input-group-text>
                                {{ fact.suffix }}
                              </b-input-group-text>
                              <b-button variant="danger" size="sm" @click="fact.value.splice(j, 1)"><b-icon
                                  icon="dash"></b-icon></b-button>
                            </b-input-group>
                          </div>
                          <button type="button" :disabled="fact.value[fact.value.length - 1] == ''"
                            class="btn btn-success" @click="fact.value.push('')"><b-icon icon="plus"></b-icon></button>
                        </div>
                        <!-- <b-form-input v-if="fact.value == 'JA' && fact.text != null" placeholder="fritext" v-model="fact.text"></b-form-input> -->

                        <!-- {{ factOptions[fact.title] }} -->
                        <!-- <b-form-group label="" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group :id="`radio-group-${i}`" v-model="fact.value" :options="fact.options" :aria-describedby="ariaDescribedby" name="radio-options"></b-form-radio-group>
                      </b-form-group> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <AdminProductVariants v-model="elementValueVariants" :orig-variants="form.variants"
                @input="elementValueVariants = $event" />

            </b-col>
            <b-col cols="4">
              <b-alert :show="form.artnr == ''"
                variant="warning"><b-icon-exclamation-triangle-fill></b-icon-exclamation-triangle-fill>
                {{ $t("text.admin.alert-no-artnr") }}</b-alert>
              <b-form-group :label="$t('text.produktbild')" v-if="form.artnr">
                <b-form-row>
                  <div class="shadow-sm w-100 border">
                    <ProductImages :artnr="form.artnr" :key="uselessNumber" @on-deleted-image="uselessNumber--">
                    </ProductImages>
                  </div>
                </b-form-row>
                <b-form-row class="mt-3" v-if="form.artnr && showOriginal">
                  <b-col>
                    <upload-product-images multiple :for-product-art="form.artnr"
                      @on-select-product-image="setProductImageData"
                      @on-uploaded-image="uploadDone(...arguments)"></upload-product-images>
                  </b-col>
                </b-form-row>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-row v-if="form.artnr" class="border rounded p-3 mt-3 mb-4">
            <b-col>
              <b-form-group>
                <upload-product-docs :language="langcode" v-if="form.artnr" multiple :for-product-art="form.artnr"
                  @on-select-product-docs="setProductDocs"></upload-product-docs>
                <small>{{ $t("text.admin.ladda-upp-bilagor-max") }} {{ maxSize | fsize }}</small>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-row>
            <b-col>
              <b-button type="button" :to="{ name: 'adm-dashboard' }" variant="outline-primary"><b-icon
                  icon="chevron-left"></b-icon> {{ $t("text.admin.ga-till-lista") }}</b-button>
            </b-col>
            <b-col align="right">
              <b-button type="submit" :disabled="preventSubmit"
                variant="primary">{{ $t("text.admin.spara") }}</b-button>
            </b-col>
          </b-row>
        </b-container>
        <div v-if="showOriginal && id">
          <hr class="mt-5 mb-0" />
          <b-container fluid class="bg-light p-md-5 px-sm-1 py-sm-3">
            <b-row>
              <b-col class="px-md-5 px-sm-0">
                <h2 class="mb-4">{{ $t("text.admin.kriterier-for") }} {{ form.name }}</h2>
                <AdminLhOptionsEdit :lhid="this.id" :lhnr="form.lockid" :lhebs="this.form.elslutbleck"
                  @on-change-slug="updateChangedEbs(...arguments)" />
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import ApiServiceAdmin from "@/services/ApiServiceAdmin";
import AdminLhOptionsEdit from "@/components/admin/AdminLhOptionsEdit";
import AdminEditMixin from "@/mixins/AdminEditMixin";
import AdminAccessMixin from "@/mixins/AdminAccessMixin";
import AdminElementsMixin from "@/mixins/AdminElementsMixin";
import AdminProductBaseSettings from "@/components/admin/AdminProductBaseSettings";
import AdminProductVariants from "@/components/admin/form/AdminProductVariants";
import _ from "lodash";
import FormElementInput from "@/components/admin/form/FormElementInput";
export default {
  name: "AdminLhEdit",
  mixins: [AdminEditMixin, AdminAccessMixin, AdminElementsMixin],
  components: {
    AdminLhOptionsEdit,
    AdminProductBaseSettings,
    AdminProductVariants,
    FormElementInput,
  },
  data() {
    return {
      preventSubmit: false,
      language: process.env.VUE_APP_I18N_LOCALE,
      spec: null,
      updatedEbs: [],
      factsOptions: {
        Dorndjup: {
          values: [{ text: "", suffix: "mm" }],
        },
        Låshustyp: {
          options: [
            { text: this.$t("Dubbelfall"), value: "Dubbelfall" },
            { text: this.$t("Enkelfall"), value: "Enkelfall" },
            { text: this.$t("Cylinderfall"), value: "Cylinderfall" },
            { text: this.$t("Tryckesfall"), value: "Tryckesfall" },
          ],
        },
        Vändbar: {
          options: [
            { text: this.$t("text.nej"), value: "NEJ" },
            { text: this.$t("text.ja"), value: "JA" },
          ],
        },
        Microbrytare: {
          options: [
            { text: this.$t("text.nej"), value: "NEJ" },
            { text: this.$t("text.ja-tillval"), value: "JA" },
          ],
        },
        Brandmotstånd: {
          options: [
            { text: this.$t("text.nej"), value: "NEJ" },
            { text: this.$t("text.ja"), value: "JA" },
          ],
        },
        "Certifierat enligt SS-EN 12209": {
          options: [
            { text: this.$t("text.nej"), value: "NEJ" },
            { text: this.$t("text.ja"), value: "JA" },
          ],
        },
        "Certifierat enligt SS-EN 179": {
          options: [
            { text: this.$t("text.nej"), value: "NEJ" },
            { text: this.$t("text.ja"), value: "JA" },
          ],
        },
        "Certifierat enligt SS-EN 1125": {
          options: [
            { text: this.$t("text.nej"), value: "NEJ" },
            { text: this.$t("text.ja"), value: "JA" },
          ],
        },
        "Låsklass enligt SSF 3522": {
          options: [
            { text: "Klass 1A", value: "Klass 1A" },
            { text: "Klass 2A", value: "Klass 2A" },
            { text: "Klass 2B", value: "Klass 2B" },
            { text: "Klass 3", value: "Klass 3" },
          ],
        },
      },
      old: {
        artnr: "",
      },
      form: {
        name: "",
        artnr: "",
        lockid: "",
        elslutbleck: [],
        variants: [],
        facts: [
          { title: "Dorndjup", value: [], suffix: "mm" },
          { title: "Låshustyp", value: [] },
          { title: "Vändbar", value: "" },
          { title: "Microbrytare", value: "" },
          { title: "Brandmotstånd", value: "" },
          { title: "Certifierat enligt SS-EN 12209", value: "" },
          { title: "Certifierat enligt SS-EN 179", value: "" },
          { title: "Certifierat enligt SS-EN 1125", value: "" },
          { title: "Låsklass enligt SSF 3522", value: "" },
        ],
        info: [
          {
            title: "Användningsområde",
            body: "",
          },
          {
            title: "Funktion",
            body: "",
          },
        ],
      },
      options: [],
      show: true,
    };
  },
  computed: {
    title: {
      get() {
        return this.form.name ? this.form.name : this.$t("text.admin.add-lh");
      },
    },
    slugs() {
      return Object.keys(this.form.spec);
    },
  },

  methods: {
    removeVariant(artnr, event) {
      event.preventDefault();
      const indexOfArtnr = _.findIndex(this.form.variants, function (v) {
        return v.artnr == artnr;
      });
      this.form.variants.splice(indexOfArtnr, 1);
    },
    uploadDone(files) {
      console.log("Upload done", files);
      this.uselessNumber++;
    },
    addEbToLh(eb) {
      // Add EB to housing.elslutbleck
      this.form.elslutbleck.push(eb);
    },
    async updateRelatedEbs() {
      // Update all related ebs
      console.log("updateRelatedEbs");
      if (this.updatedEbs.length) {
        this.updatedEbs.forEach((eb) => {
          console.log("eb", eb);
          ApiServiceAdmin.updateEbById(eb._id, { name: eb.name, artnr: eb.artnr, spec: eb.spec, facts: eb.facts, info: eb.info, published: eb.published, translations: eb.translations });
        });
      }
    },
    async updateChangedEbs(ebsFromTable) {
      console.log("updateChangedEbs", ebsFromTable);
      this.form.elslutbleck = await _.map(ebsFromTable, (eb) => ({
        _id: eb._id,
      }));
      this.updatedEbs = await _.map(ebsFromTable, (eb) => eb);
    },
    async initFormData() {
      try {
        const response = await ApiServiceAdmin.getLhDataById(this.id, [])
        const form = _.pick(response.data, ["name", "artnr", "lockid", "enr", "nobnr", "elslutbleck", "info", "facts", "variants", "published", "translations"]);


        this.form = form
        // this.form.translations[this.langcode].variants = _.map(this.form.variants, (v, i) => {
        //   // Need this for the page not to crash
        //   if (this.form.translations[this.langcode].variants[i] === undefined) {
        //     return { title: "", artnr: "" };
        //   }
        //   return { title: this.form.translations[this.langcode].variants[i].title ? this.form.translations[this.langcode].variants[i].title : "", artnr: this.form.translations[this.langcode].variants[i].artnr ? this.form.translations[this.langcode].variants[i].artnr : "" };
        // });
        // console.log('HELLO 2')
        this.old.artnr = this.form.artnr;
      } catch (error) {
        console.error(error);
      }
    },
    onSubmit(event) {
      event.preventDefault();
      this.loading = true;
      console.log('DONE')
      if (!this.id) {
        ApiServiceAdmin.addLh(JSON.stringify(this.form))
          .then((response) => {
            console.log("response", response);
            this.$router.push(`/admin/lh/${response.data.result._id}`);
            this.id = response.data.result._id;
            this.handleSuccess(response);
          })
          .catch(this.handleError);
      } else {
        ApiServiceAdmin.updateLhById(this.id, JSON.stringify(this.form))
          .then((response) => {
            // Update folder name in S3
            if (this.form.artnr != this.old.artnr) {
              console.log("Update folder name in S3");
              ApiServiceAdmin.updateFolderByArt(this.form.artnr, this.old.artnr)
                .then(() => {
                  this.old.artnr = this.form.artnr;
                  // this.makeToast({ variant: "info", title: this.$t("messages.post-update-artnr"), text: this.$t("messages.post-save") });
                })
                .catch(this.handleError);
            }
            // Update related ebs
            this.updateRelatedEbs();
            this.handleSuccess(response);
          })
          .catch(this.handleError);
      }
    },
    onChange() {
      let variants = this.form.variants
      if (this.langcode !== 'se') {
        variants = this.form.translations[this.langcode].variants
      }
      console.log('variants', variants)
      variants.forEach(async (variant) => {
        const unique_enr = await this.isUnique('enr', variant.enr, this.id)
        const unique_nobnr = await this.isUnique('nobnr', variant.nobnr, this.id)
        if (!unique_enr || !unique_nobnr) {
          // Prevent saving if not unique
          this.handleError('E11000_DUPLICATE_KEY')
          this.preventSubmit = true;
          return false;
        }
      });
      this.preventSubmit = false;
    },
  }
};
</script>

<style scoped>
.input-gap {
  gap: 10px;
}
</style>
